import React from 'react';
import SectionQuote from './SectionQuote';

function About() {
  return (
    <section className="about section" aria-label="About Cathosis">
      <SectionQuote>Let's bust through!</SectionQuote>
      <div className="prose">
        <p>
          Cathosis{' '}
          <span className="about__portmanteau">
            <span className="about__root">cathode</span>
            <span className="about__plus">+</span>
            <span className="about__root">catharsis</span>
          </span>{' '}
          is an independent studio from the north woods of Minnesota. We make
          original games like the ones we love, from an era of gaming that ended
          far too soon.
        </p>
        <p>
          You know the ones. The RPGs with casts of dozens. The platformers that
          felt perfect. The tactics games you're still thinking about twenty
          years later. The sequels that never got made.
        </p>
        <p>We're making them.</p>
      </div>
    </section>
  );
}

export default About;
